import React from 'react';
import { Button, Card } from '../components/ui';
import { clearToken } from '../api/client';
import { useAppContext } from '../store/AppContext';

interface Props {
  onLogout: () => void;
}

export const SettingsPage: React.FC<Props> = ({ onLogout }) => {
  const { user } = useAppContext();

  const handleLogout = () => {
    clearToken();
    onLogout();
  };

  return (
    <div style={{ padding: '32px', maxWidth: 640, margin: '0 auto' }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 24 }}>Settings</h1>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <Card title="Profile">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-muted)', marginBottom: 4 }}>
                Display name
              </div>
              <div style={{ fontSize: 14 }}>{user?.displayName ?? '—'}</div>
            </div>
            <div>
              <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-muted)', marginBottom: 4 }}>
                Email
              </div>
              <div style={{ fontSize: 14 }}>{user?.email ?? '—'}</div>
            </div>
          </div>
        </Card>

        <Card title="Account">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)' }}>
              This is an MVP settings page. More options coming soon.
            </p>
            <Button variant="danger" onClick={handleLogout}>
              Sign out
            </Button>
          </div>
        </Card>

        <Card title="About">
          <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            better_local_slock v0.1.0 — Local-first AI team collaboration platform.
          </p>
        </Card>
      </div>
    </div>
  );
};
